//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import util from '@/lib/util';
import {formatDate} from "../../../lib/date";

export default {
    name: "ticketList",
    filters: {
        formatDate(time, type) {
            var date = new Date(time);
            if (type == 1) {
                return formatDate(date, 'yyyy/MM/dd');
            }
            return formatDate(date, 'yyyy-MM-dd hh:mm');
        }
    },
    data() {
        return {
            pageSize: 15,
            currentPage: 1,
            totalCount: 0,
            // list: [
            //     {
            //         shopName: '川味酸菜鱼',
            //         colDate: '2020-04-09 12:30',
            //         tit: '品质联盟专项优惠券',
            //         ticketCode: '000020200406',
            //         useTime: '2020-04-05 至 2020-06-030',
            //         status: '已使用'
            //     },
            //     {
            //         shopName: '川味酸菜鱼',
            //         colDate: '2020-04-09 12:30',
            //         tit: '品质联盟专项优惠券',
            //         ticketCode: '000020200406',
            //         useTime: '2020-04-05 至 2020-06-030',
            //         status: '已使用'
            //     }
            // ],
            list: [],
            refreshing: false,
            pageIndex: 0,
            pageSize: 10,
            loading: false,
            finished: false,
            downloadUrl: util.ApiUrl + '/file/download/',
            shopId: 0
        }
    },
    methods: {
        onRefresh() {
            this.pageIndex = 1;
            this.getPage();
        },
        onLoad() {
            this.pageIndex++;
            this.getPage()
        },
        getPage() {
            this.refreshing = this.pageIndex === 1;
            this.loading = this.pageIndex > 1;
            var page = {
                shopId: this.shopId,
                maxResultCount: this.pageSize,
                skipCount: (this.pageIndex - 1) * this.pageSize
            };
            abp.ajax.post('/api/services/app/Coupon/SearchShopCoupons', page).then((res) => {
                if (this.pageIndex === 1) {
                    this.list = [];
                }
                this.list.push(...res.data.result.items);
                // console.log(this.list);
                if (res.data.result.items.length < this.pageSize) {
                    this.finished = true;
                } else {
                    this.finished = false;
                }
            }).then(() => {
                this.refreshing = false;
                this.loading = false;
            }).catch((error) => {
                this.refreshing = false;
                this.loading = true;
            }).finally(() => {
                // this.refreshing = false;
                // this.loading = true;
            });
        },
        goToDetail(item) {
            // this.$router.push({path: '/businessDetail/' + item.code + '/' + this.shopId})
            this.$router.push({path: '/ticketDetail/' + item.id})
        }
    },
    created() {
        /*this.getPage()*/
        this.shopId = parseInt(this.$route.params.shopId);

        this.onRefresh();
    }
}
